/**
 * Runtime config read from `/config.js`, which the container writes at start
 * (frontend.md §7.2). Nothing about the deployment hostname is ever baked into
 * the bundle, so one image runs on any hostname.
 */

export interface RuntimeConfig {
  wsPath: string;
  apiBase: string;
  sentryDsn: string;
  build: string;
}

declare global {
  interface Window {
    __ORDAGO_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const injected = window.__ORDAGO_CONFIG__ ?? {};

export const runtimeConfig: RuntimeConfig = {
  wsPath: injected.wsPath ?? '/ws',
  apiBase: injected.apiBase ?? '/api',
  sentryDsn: injected.sentryDsn ?? '',
  build: injected.build ?? 'dev',
};
